<template>
    <div class="navbar">
        <div class="hamburger-btn" @click="$emit('update:showSidebar', !showSidebar)">
            <i v-if="showSidebar" class="fa-solid fa-x"></i>
            <i v-else class="fa-solid fa-bars"></i>
        </div>
    </div>
</template>

<script>


export default {
    name: "Navbar",
    props: {
        showSidebar: {
            type: Boolean,
            required: true,
        }
    },
}
</script>